import { Note } from "common";
import { useNoteTeam } from "./useNoteTeam";

export const useNoteTeamName = (note: Note) => {
  const team = useNoteTeam(note);
  if (team) {
    return team.name;
  }
  return `Deleted Team`;
};
